/**
 * <TutorSessionRosterSkeleton> — la forme de `<TutorSessionRoster>` pendant un premier chargement.
 *
 * Une ligne par élève, et la ligne d'un élève est celle d'une séance à son échelle : la chip de sa
 * matière, puis « Jules M. · 4ᵉ · Maths » à la hauteur d'une chip (`DETAILS_LINE_BOX`). Elle reprend
 * donc `<SessionDetailsLineSkeleton>`, sans recopier sa géométrie. Le cas montré est le cas courant :
 * deux élèves, un cours partagé.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { SessionDetailsLineSkeleton } from "../SessionDetailsLine"

/** Les barres des noms, du plus long au plus court : deux élèves n'ont pas la même ligne. */
const WIDTHS = [150, 125, 140]

export type TutorSessionRosterSkeletonProps = {
    /** Le nombre d'élèves montrés. Défaut 2. */
    students?: number
}

export function TutorSessionRosterSkeleton(props: TutorSessionRosterSkeletonProps) {
    const { students = 2 } = props

    return (
        <Stack gap="1">
            {Array.from({ length: students }, (_, index) => (
                <SessionDetailsLineSkeleton key={index} width={WIDTHS[index % WIDTHS.length]} />
            ))}
        </Stack>
    )
}
